// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"m3-z","dimensionLabel":"n3-z","styleChooserControlWrapper":"o3-z","styleChooserControl":"p3-z","disabled":"q3-z","giftCard":"r3-z","styleChooserText":"s3-z"};